import { useEffect, useState } from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/style.css";
import { DailySummary } from "./DailySummaryView";
import { Panel } from "../../../../../components/Panel";
import { MonthSelect } from "./MonthSelect";
import { YearFilter } from "./YearFilter";
import { useApp } from "../../../../../helpers/app-context";
import { api } from "../../../../../helpers/api";
import moment from "moment";
import { Calendar } from "../../calendar/components/Calendar";
import Spinner from "../../../../../components/Spinners";

export function CalendarView({ user }) {
  const [isLoading, setIsLoading] = useState(false);
  const [calendarData, setCalendarData] = useState<any[]>([]);
  const { isChatBotOpen, sidebarExpanded } = useApp() as {
    isChatBotOpen: boolean;
    sidebarExpanded: boolean;
  };

  const [selectedMonth, setSelectedMonth] = useState<any>(
    new Date().getMonth() + 1
  );
  const [selectedYear, setSelectedYear] = useState<any>(
    new Date().getFullYear()
  );

  const handleMonthChange = (month: string) => {
    setSelectedMonth(Number(month) - 1);
  };

  const handleYearChange = (year: string) => {
    setSelectedYear(Number(year));
  };

  useEffect(() => {
    if (user?.id) {
      setIsLoading(true);
      const date = moment(
        `${selectedMonth}-${selectedYear}`,
        "MM-YYYY"
      ).format();
      const startDate = moment(date).startOf("month").format("YYYY-MM-DD");
      const endDate = moment(date).endOf("month").format("YYYY-MM-DD");
      api
        .getCalendarData(user.id, startDate, endDate)
        .then((res) => {
          setCalendarData([...res]);
        })
        .catch((err) => console.log(err))
        .finally(() => setIsLoading(false));
    }
  }, [selectedMonth, selectedYear, user?.id]);

  return (
    <Panel
      label="Calendar"
      actions={
        <div className="flex items-center gap-1.5">
          <MonthSelect
            disabled={false}
            value={`${selectedMonth}`}
            onChange={handleMonthChange}
          />
          <YearFilter
            disabled={false}
            value={`${selectedYear}`}
            onChange={handleYearChange}
          />
        </div>
      }
      className={`h-full flex flex-col ${
        isChatBotOpen || sidebarExpanded ? "tall3:pb-[5.75rem]" : "pb-[6.5rem]"
      }`}
    >
      <div className="p-3">
        {isLoading ? (
          <div className="flex justify-center items-center h-full">
            <Spinner className="!text-primary" />
          </div>
        ) : (
          <Calendar
            year={selectedYear}
            month={selectedMonth}
            calendarData={calendarData}
            user={user}
          />
        )}
      </div>
      {/* <div className="w-fit !text-2xs p-3">
        <DayPicker
          mode="single"
          month={new Date(selectedYear, selectedMonth)}
          components={{
            DayButton: (props) => {
              const { day, modifiers, ...buttonProps } = props;
              return (
                <DayView
                  buttonProps={{
                    ...buttonProps,
                  }}
                  date={day.date}
                />
              );
            },
          }}
        />
      </div> */}
    </Panel>
  );
}
